import { Divider as CoreDivider, InputLabel as CoreInputLabel } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Label = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: ${colorTokens.text.dark};
`;

export const List = styled.ul`
  list-style-position: inside;
  margin-left: 16px;
`;

export const Divider = styled(CoreDivider)`
  margin: 10px 0;
`;

export const Content = styled.div`
  color: ${colorTokens.text.medium};
  font-weight: 300;
`;

export const InputLabel = styled(CoreInputLabel)`
  width: 25%;
`;

export const MarginLeft = styled.span`
  margin-left: 10px;
`;
